module.exports = __webpack_public_path__ + "img/M300J.5698deb1.png";